<i18n
  src="@/locales/views/service_provider/warehouse/movements/edit_item.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/inventory_item.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_warehouse_items')"
    :params="{
      service_provider_id: service_provider_id,
      warehouse_id: warehouse_id,
    }"
  />
  <bread-crumbs :labels="[module_name, warehouse.name]"></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.inventory_item.item_code") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="inventory_item.item_code"
                  :class="['input-text', isInvalid('item_code')]"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.inventory_item.name") }}
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  v-model.trim="inventory_item.name"
                  :class="['input-text', isInvalid('name')]"
                />
              </div>
            </div>

            <div class="sm:col-span-3">
              <label class="label-form">
                {{ $t("model.inventory_item.inventory_unit") }}
              </label>
              <div class="mt-1">
                <select-form
                  :options="inventory_units"
                  v-model="inventory_item.inventory_unit_id"
                  :is_invalid="isInvalidSelect('inventory_unit')"
                />
              </div>
            </div>
          </div>
          <div class="pt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.inventory_item.description") }}
              </label>
              <div class="mt-1">
                <textarea
                  v-model="inventory_item.description"
                  rows="3"
                  class="input-text-area"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToShowWarehouse"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="update"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>

  <loading-message v-else />
</template>

<script>
import Requester from "@/views/service_provider/requesters/warehouse/movements/manage_inventory_items.js";

export default {
  name: "SPWarehouseMovementsEditItem",
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      warehouse: {},
      inventory_units: [],
      inventory_item: {},
    };
  },
  props: {
    service_provider_id: { required: true },
    warehouse_id: { required: true },
    id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      this.fetchWarehouse();
      await this.fetchInventoryItem();
      this.fetchInventoryUnits();
      this.load_general_data = true;
    },

    fetchWarehouse: async function () {
      let response = await Requester.fetchWarehouse(
        this.service_provider_id,
        this.warehouse_id
      );

      this.warehouse = response.data;
    },

    fetchInventoryItem: async function () {
      let response = await Requester.fetchInventoryItem(
        this.service_provider_id,
        this.warehouse_id,
        this.id
      );

      this.inventory_item = response.data;
    },

    fetchInventoryUnits: async function () {
      let response = await Requester.fetchInventoryUnits(
        this.service_provider_id,
        this.warehouse_id
      );

      this.inventory_units = response.data;
    },

    update: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.update(
          this.service_provider_id,
          this.warehouse_id,
          this.id,
          this.inventory_item
        );

        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowWarehouse();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
        this.proc_save_button = false;
      }
    },
    goToShowWarehouse: function () {
      this.$router.push({
        name: this.routeName("show_warehouse_items"),
        params: {
          service_provider_id: this.service_provider_id,
          warehouse_id: this.warehouse_id,
        },
      });
    },
  },
};
</script>
